import { Effect, Reducer } from '@umijs/max';
import {
  getAffiliateAges,
  getAffiliatePkis,
  getAffiliateGender,
  getAffiliateCreated,
  getAffiliateWarnings,
  getAffiliateHirarchies,
  getAffiliateDestinations,
  getAffiliateDistribution,
  getAffiliateDestinationsComplex,
  getAffiliatePrincipalDistribution,
  getAffiliateRelativesDistribution,
} from '@/services/affiliates.service';

export interface StateType {
  affiliateAges: any[] | null;
  affiliateCreated: any[] | null;
  affiliateDestinations: any[] | null;
  affiliateDestinationsComplex: any[] | null;

  affiliateHirarchies: any[] | null;
  affiliateDistribution: any[] | null;
  affiliatePrincipalDistribution: any[] | null;
  affiliateRelativesDistribution: any[] | null;

  affiliatePkis: any;
  affiliateGender: any;
  affiliateWarnings: any;
}

export interface ModelType {
  namespace: string;
  state: StateType;

  effects: {
    reset: Effect;
    getAffiliatePkis: Effect;
    getAffiliateAges: Effect;
    getaffiliateGender: Effect;
    getAffiliateCreated: Effect;
    getAffiliateWarnings: Effect;
    getAffiliateHirarchies: Effect;
    getAffiliateDistribution: Effect;
    getAffiliateDestinations: Effect;
    getAffiliateDestinationsComplex: Effect;
    getAffiliatePrincipalDistribution: Effect;
    getAffiliateRelativesDistribution: Effect;
  };

  reducers: {
    resetState: Reducer<any>;
    setAffiliatePkis: Reducer<any>;
    setAffiliateAges: Reducer<any>;
    setAffiliateGender: Reducer<any>;
    setAffiliateCreated: Reducer<any>;
    setAffiliateWarnings: Reducer<any>;
    setAffiliateHirarchies: Reducer<any>;
    setAffiliateDistribution: Reducer<any>;
    setAffiliateDestinations: Reducer<any>;
    setAffiliateDestinationsComplex: Reducer<any>;
    setAffiliatePrincipalDistribution: Reducer<any>;
    setAffiliateRelativesDistribution: Reducer<any>;
  };
}

const Model: ModelType = {
  namespace: 'affiliateStats',

  state: {
    affiliatePkis: null,
    affiliateAges: null,
    affiliateGender: null,
    affiliateCreated: null,
    affiliateWarnings: null,
    affiliateHirarchies: null,
    affiliateDestinations: null,
    affiliateDestinationsComplex: null,

    affiliateDistribution: null,
    affiliatePrincipalDistribution: null,
    affiliateRelativesDistribution: null,
  },

  effects: {
    *reset(_, { put }) {
      yield put({
        type: 'resetState',
      });
    },

    *getAffiliatePkis({ payload }, { call, put, all }) {
      const [response] = yield all([call(getAffiliatePkis, payload)]);
      
      yield put({
        type: 'setAffiliatePkis',
        payload: response.data,
  
      });
    },

    *getaffiliateGender({ payload }, { call, put, all }) {
      const [response] = yield all([call(getAffiliateGender, payload)]);
      yield put({
        type: 'setAffiliateGender',
        payload: response.data,
      });
    },

    *getAffiliateAges({ payload }, { call, put, all }) {
      const [response] = yield all([call(getAffiliateAges, payload)]);
      yield put({
        type: 'setAffiliateAges',
        payload: response.data,
      });
    },

    *getAffiliateCreated({ payload }, { call, put, all }) {
      const [response] = yield all([call(getAffiliateCreated, payload)]);
      yield put({
        type: 'setAffiliateCreated',
        payload: response.data,
      });
    },

    *getAffiliateHirarchies({ payload }, { call, put, all }) {
      const [response] = yield all([call(getAffiliateHirarchies, payload)]);
      yield put({
        type: 'setAffiliateHirarchies',
        payload: response.data,
      });
    },

    *getAffiliateDestinations({ payload }, { call, put, all }) {
      const [response] = yield all([call(getAffiliateDestinations, payload)]);
      yield put({
        type: 'setAffiliateDestinations',
        payload: response.data,
      });
    },

    *getAffiliateDestinationsComplex({ payload }, { call, put, all }) {
      const [response] = yield all([
        call(getAffiliateDestinationsComplex, payload),
      ]);
      yield put({
        type: 'setAffiliateDestinationsComplex',
        payload: response.data,
      });
    },

    *getAffiliateWarnings({ payload }, { call, put, all }) {
      const [response] = yield all([call(getAffiliateWarnings, payload)]);
      yield put({
        type: 'setAffiliateWarnings',
        payload: response.data,
      });
    },

    *getAffiliateDistribution({ payload }, { call, put, all }) {
      const [response] = yield all([call(getAffiliateDistribution, payload)]);
      yield put({
        type: 'setAffiliateDistribution',
        payload: response.data,
      });
    },

    *getAffiliatePrincipalDistribution({ payload }, { call, put, all }) {
      const [response] = yield all([
        call(getAffiliatePrincipalDistribution, payload),
      ]);
      yield put({
        type: 'setAffiliatePrincipalDistribution',
        payload: response.data,
      });
    },

    *getAffiliateRelativesDistribution({ payload }, { call, put, all }) {
      const [response] = yield all([
        call(getAffiliateRelativesDistribution, payload),
      ]);
      yield put({
        type: 'setAffiliateRelativesDistribution',
        payload: response.data,
      });
    },
  },

  reducers: {
    resetState() {
      return {};
    },

    setAffiliatePkis(state, { payload }) {
      
      return {
        ...state,
        affiliatePkis: payload,
      };
    },

    setAffiliateGender(state, { payload }) {
      return {
        ...state,
        affiliateGender: payload,
      };
    },

    setAffiliateAges(state, { payload }) {
      return {
        ...state,
        affiliateAges: payload,
      };
    },

    setAffiliateHirarchies(state, { payload }) {
      return {
        ...state,
        affiliateHirarchies: payload,
      };
    },

    setAffiliateCreated(state, { payload }) {
      return {
        ...state,
        affiliateCreated: payload,
      };
    },

    setAffiliateWarnings(state, { payload }) {
      return {
        ...state,
        affiliateWarnings: payload,
      };
    },

    setAffiliateDestinations(state, { payload }) {
      return {
        ...state,
        affiliateDestinations: payload,
      };
    },

    setAffiliateDestinationsComplex(state, { payload }) {
      return {
        ...state,
        affiliateDestinationsComplex: payload,
      };
    },

    setAffiliateDistribution(state, { payload }) {
      return {
        ...state,
        affiliateDistribution: payload,
      };
    },

    setAffiliateRelativesDistribution(state, { payload }) {
      return {
        ...state,
        affiliateRelativesDistribution: payload,
      };
    },

    setAffiliatePrincipalDistribution(state, { payload }) {
      return {
        ...state,
        affiliatePrincipalDistribution: payload,
      };
    },
  },
};

export default Model;
